export class ConcurrencyCheckFailed {
    static $type = 'SAM.Workflow.Core.ExceptionMessages.ConcurrencyCheckFailed, SAM.Workflow.Core';

    toString() {
        return 'The element has been modified and saved by another user or process since it was loaded. To avoid data loss, the operation has been cancelled. Please reload the item and try again.';
    }
}